import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { ProjectDiagramTileId } from 'src/constants/mosaic';
import { PROJECT_DIAGRAM_RESCALE_PARAM } from 'src/constants/project';
import { ProjectDiagramModelList } from 'src/containers/ProjectDiagram/components/modelList/ProjectDiagramModelList';
import { useContextMenu } from 'src/containers/ProjectDiagram/hooks/useContextMenuValue';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ProjectDiagramContainer } from 'src/containers/ProjectDiagram/ProjectDiagramContainer';
import { redrawLayout } from 'src/containers/ProjectDiagram/templates/extensions/layouts/utils/redrawLayout';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const ProjectDiagramView = () => {
  const [contextMenu, setContextMenu] = useContextMenu();
  const diagram = useDiagram();
  const history = useHistory();
  const isModelListOpen = useReduxSelector(
    (state) => state.ui.modelList.isOpen
  );

  React.useEffect(() => {
    const { search, pathname } = history.location;
    const params = new URLSearchParams(search);

    if (params.has(PROJECT_DIAGRAM_RESCALE_PARAM) && diagram) {
      history.replace(pathname);
      commitDiagramWhileSkippingUndoManager(diagram, redrawLayout);
    }
  }, [diagram, history]);

  return (
    <div className="sd-project-diagram-view">
      <ProjectDiagramContainer
        contextMenu={contextMenu}
        id={ProjectDiagramTileId.VIEW}
        onContextMenuClose={() => {
          setContextMenu(null);
          // return focus to gojs
          diagram?.toolManager.contextMenuTool.doCancel();
        }}
      />
      {isModelListOpen ? <ProjectDiagramModelList /> : null}
    </div>
  );
};
